/**
 * Accepted text length for generated boards; mirrors lib/whiteboard_text_limits.py.
 *
 * The schema and policies keep asking the model for the original lengths. Bedrock
 * structured output does not enforce `maxLength`, so validators accept a bounded
 * overrun. Item counts stay exact.
 */
export const TEXT_LENGTH_TOLERANCE = 1.5;

/** Longest accepted text for a requested `limit` characters. */
export function textLimit(limit: number): number {
  return Math.floor(limit * TEXT_LENGTH_TOLERANCE);
}
